import type { UploadProps } from 'antd'
import Modal from 'antd/es/modal/Modal'
import { RcFile } from 'antd/es/upload'
import { I18nContext } from 'contexts/I18n/I18nProvider'
import React, { useContext, useState } from 'react'
import '../index.scss'
import UploadComponent from './Upload'

type UploadModalProps = {
  validationCallback?: (file: RcFile) => void
  onConfirmCallback: (file: RcFile) => void
  onCancelCallback?: () => void
  onFailedFileValidation?: () => void
  props: UploadProps
  title?: string
  subtitle?: string
  confirmDisabled: boolean
  icon?: React.ReactNode
}

export default function UploadModal({
  validationCallback,
  props,
  title = 'upload.file_upload',
  subtitle,
  confirmDisabled,
  onConfirmCallback,
  onCancelCallback,
  onFailedFileValidation,
  icon
}: UploadModalProps) {
  const t = useContext(I18nContext)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [file, setFile] = useState<RcFile>()

  const showModal = () => {
    setIsModalOpen(true)
  };

  const handleOk = () => {
    if (file) {
      onConfirmCallback(file)
      setIsModalOpen(false)
    }
  };

  const handleCancel = () => {
    if (onCancelCallback) {
      onCancelCallback()
    }
    setIsModalOpen(false)
  };

  return (
    <>
      <button
        className="button is-larger is-primary"
        onClick={showModal}
      >
        {t('general.upload')}
      </button>
      <Modal
        classNames={{ content: 'upload-modal' }}
        title={t(title)}
        centered
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        onCancel={handleCancel}
        destroyOnHidden
        footer={[
          <button key="ok" className="button is-larger is-primary" onClick={handleOk} disabled={confirmDisabled}>
            {t('general.confirm')}
          </button>,
          <button key="cancel" className="button is-larger" onClick={handleCancel}>
            {t('general.cancel')}
          </button>
        ]}
      >
        <UploadComponent
          setFile={setFile}
          onFileValidation={validationCallback}
          props={props}
          subtitle={subtitle}
          icon={icon}
          onFailedFileValidation={onFailedFileValidation}
        />
      </Modal>
    </>
  );
}
